import { HttpService } from "@/utils/request";

/**
 * 保存传媒客户
 * @param query
 * @returns {*}
 */
export function saveMediaCustomers(query) {
    return HttpService({
        url: "/equipment/saveAdvertisementCustomer",
        method: "POST",
        data: query
    });
}
/**
 * 获取传媒客户列表
 * @param query
 * @returns {*}
 */
export function getMediaCustomersList(query) {
    return HttpService({
        url: "/equipment/listAdvertisementCustomer",
        method: "POST",
        data: query
    });
}
/**
 * 获取传媒客户详情
 * @param query
 * @returns {*}
 */
export function getMediaCustomersInfo(query) {
    return HttpService({
        url: "/equipment/detailAdvertisementCustomer",
        method: "POST",
        data: query
    });
}
/**
 * 删除
 * @param query
 * @returns {*}
 */
export function deleteMediaCustomersInfo(query) {
    return HttpService({
        url: "/equipment/deleteAdvertisementCustomer",
        method: "POST",
        data: query
    });
}
